//
//
//
//
//
//
//
//
//
//
//
//

export default {
  // you can set a custom layout for the error page
  layout: process.env.MAINTENANCE_MODE ? "maintenance" : "content",
  props: {
    // eslint-disable-next-line vue/require-default-prop
    error: Object,
  },
};
